import { clsx } from "clsx";

/** 1–5 energy as filled pips; carries an accessible label so colour/shape is not the only signal. */
export function EnergyPips({
  value,
  label,
  size = 6,
  onChange,
}: {
  value: number;
  label: string;
  size?: number;
  onChange?(v: number): void;
}) {
  const pips = [1, 2, 3, 4, 5];
  const Tag = onChange ? "button" : "span";
  return (
    <span
      className="inline-flex items-center gap-[3px]"
      role={onChange ? "radiogroup" : "img"}
      aria-label={label}
      title={label}
    >
      {pips.map((p) => (
        <Tag
          key={p}
          type={onChange ? "button" : undefined}
          role={onChange ? "radio" : undefined}
          aria-checked={onChange ? p === value : undefined}
          aria-label={onChange ? String(p) : undefined}
          onClick={onChange ? () => onChange(p) : undefined}
          className={clsx(
            "rounded-full border transition",
            p <= value
              ? "border-neutral-700 bg-neutral-700 dark:border-neutral-300 dark:bg-neutral-300"
              : "border-neutral-300 dark:border-neutral-700",
            onChange && "hover:border-accent",
          )}
          style={{ width: size, height: size, padding: 0 }}
        />
      ))}
    </span>
  );
}
